import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, Suspense as _Suspense } from "vue"

const _hoisted_1 = { class: "confirm-order-title" }
const _hoisted_2 = { class: "confirm-order-table" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flex-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "el-dropdown-link cursor-pt",
  style: {"color":"#0586FE","margin-left":"10px"}
}, " 请选择> ", -1)
const _hoisted_12 = { class: "dropdown-content" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "checked" }
const _hoisted_15 = {
  key: 0,
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/checked_icon.png",
  alt: ""
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/ship_icon.png",
  alt: "",
  class: "icon"
}, null, -1)
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "checked" }
const _hoisted_19 = {
  key: 0,
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/checked_icon.png",
  alt: ""
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/air_icon.png",
  alt: "",
  class: "icon"
}, null, -1)

import RestockTable from './components/RestockTable.vue'
import UnRechargeModal from '@/components/UnRechargeModal/index.vue'
import UnBalanceConfirm from '@/components/UnBalanceConfirm/index.vue'
import bus from '@/util/useBus'
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'
import STable from '@/components/Table/index.vue'
import FigurePay from '@/views/shopcart/components/FigurePay.vue'
import { confirmOrderDetailApi, editOrderGoodsAdditionApi, editTransportTypeApi } from '@/apis/order'
import { columns, childColumns, choiceColumns, choiceChildColumns } from './data'
import { useRoute, useRouter } from 'vue-router'
import { ElMessageBox, ElMessage } from 'element-plus'
import { useRtfix, usePlat, isD2C, isJA, useSite2Station } from '@/store'
import NoStockModal from '@/views/shopcart/components/NoStockModal.vue'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import { montageAddition } from '@/util/calcAdt'
import { showCurrentUnit } from '@/util/useYan'
import { COUNTRY } from '@/global'
import AllPriceDetail from '@/views/shopcart/components/choice/AllPriceDetail.vue'
import { showModal } from '.'
import { getWallet } from '@/apis/user'
import Recharge from '@/views/shopcart/components/choice/Recharge.vue'
import CreateOrderSuccess from '@/views/shopcart/components/choice/CreateOrderSuccess.vue'
import { request } from '@/config/request/interceptors'
import { getCustomerWalletList, getUnCheckMoney } from '@/apis/fund'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const unBalanceConfirmRef = ref()
const route = useRoute()
const router = useRouter()
const store = useStore()
const table = ref()
const tableData: any = ref([])
const pdtFee = ref(0)
const adtFee = ref(0)
const figurePayRef = ref()
const visible = ref(false)
const goods: any = ref([])
const blackGoods: any = ref([])
const isRestockOrder = ref(!!route.query.isReplenish)
// 目前choice不进待支付列表页
const isChoice = ref(false)
const choiceTotalAmount = computed(() => {
  console.log('tableData.value', tableData.value)
  let list: any = []
  tableData.value.forEach((item: any) => {
    list = [
      ...list,
      ...(item?.platformOrderItems ?? [])
    ]
  })
  const a = {
    totalAmt: list.reduce((total: number, v: any): number => {
      return total + (v.allIncludePriceResultDetail?.allIncludeProductTotalPriceExchange ?? 0)
    }, 0),
    totalAmtCn: list.reduce((total: number, v: any): number => {
      return total + (v.allIncludePriceResultDetail?.allIncludeProductTotalPrice ?? 0)
    }, 0),
    totalPriceCNY: list.reduce((total: number, v: any): number => {
      return total + (v.allIncludePriceResultDetail?.allIncludeProductTotalPrice ?? 0)
    }, 0)?.toFixed(2),
    totalPriceJPY: list.reduce((total: number, v: any): number => {
      return total + (v.allIncludePriceResultDetail?.allIncludeProductTotalPriceExchange ?? 0)
    }, 0),
    totalQuantity: list.reduce((total: number, v: any): number => {
      return total + (v.orderQuantity ?? 0)
    }, 0)
  }
  console.log('11111', list, a)
  return a
})
const tableConfig = {
  // showSelection: true,
  // showHandler: true,
  showExpand: true,
  canRowClick: true,
  rowKey: 'platformOrderId',
  setHeight: true
}
const rechargeRef = ref()
const submit = async () => {
  const noAdtItem = tableData.value.filter(v => v.orderSource === 10 && v.platformOrderItems.find(k => k.noAdditionalFlag !== 1 && !k.platformOrderItemAdditionList))
  if (noAdtItem.length > 0) {
    ElMessage.warning(t('附加项验证'))
    if (!table.value?.isFilp(noAdtItem[0])) {
      table.value.expandRowChange(noAdtItem[0])
    }
    return
  }
  const api = isRestockOrder.value ? request.order.customer.platformOrderPay({
    platformOrderId: route.query.id as any
  }) : request.order.excel.batchPay({
    platformOrderIds: (route.query.id?.toString().split(',') || []) as any
  })
  const res = await api
  if (res.success) {
    const { stockSkus, downSkus, validSkus, blackSkuList, firstOrderFlag, meetFreeShipFlag } = res.data!
    if (stockSkus?.length || blackSkuList?.length) {
      const list: any = []
      const blackList: any = []
      tableData.value.forEach((item: any) => {
        item.platformOrderItems.forEach((temp: any) => {
          if (stockSkus?.includes(temp.productSku) && temp.channel === 5) {
            list.push({
              ...temp,
              price: temp.actualPrice
            })
          }
          if (blackSkuList?.includes(temp.productSku)) {
            blackList.push({
              ...temp,
              price: temp.actualPrice
            })
          }
        })
      })
      if (list.length > 0 || blackList.length > 0) {
        goods.value = list
        blackGoods.value = blackList
        visible.value = true
      } else {
        ElMessage.warning(t('支付失败'))
      }
      return
    } else if (downSkus?.length || validSkus?.length) {
      ElMessage.warning(t('支付失败'))
      return
    }
    if (isJA()) {
      localStorage.setItem('ckb_last_order_id', res.data?.platformOrderId ?? route.query.id as any)
      if (firstOrderFlag) {
        window.location.href = `/order_complete_first?hasCoupon=${meetFreeShipFlag ? 1 : 0}`
      } else {
        window.location.href = '/order_complete'
      }
    } else {
      ElMessageBox.confirm(
        t('支付成功'),
        t('提示'),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: t('确定'),
          distinguishCancelAndClose: true,
          customClass: 'stupid-el',
          type: 'success',
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false
        }
      ).then(() => {
        router.push(useRtfix('OrderList'))
      })
    }
  } else {
    if (res.code === '22010002') {
      if (isChoice.value) {
        rechargeRef.value.open()
        return
      }
      getCustomerWalletList({
        stationCode: useSite2Station(),
        currencyCode: tableData.value[0]?.goodsCountry === COUNTRY.KR ? 'KRW' : 'CNY'
      }).then(async (res: any) => {
        const { data } = res
        const recharge = data.find?.((e: any) => e.accountType === 1)?.availableAmount ?? 0
        const unCheckCnyAmt = await getUnCheckMoney({ currencyCode: tableData.value[0]?.goodsCountry === COUNTRY.KR ? 'KRW' : 'CNY' }).then(res => {
          return res.data.unCheckCnyAmt
        })
        if (recharge > 0 || unCheckCnyAmt > 0) {
          bus.emit('openUnRechargeModal', {
            currency: tableData.value[0]?.goodsCountry === COUNTRY.KR ? 'KRW' : 'CNY',
            unCheckCnyAmt
          })
        } else {
          unBalanceConfirmRef.value?.open()
          // showModal(router)
        }
      })
    }
    if (res.code === '22010091') {
      ElMessage.warning(t('待支付的订单才能重新支付，请确认后重新选择'))
    }
  }
}
const getDetail = () => {
  confirmOrderDetailApi({
    platformOrderIds: route.query.id?.toString().split(',') || []
  }).then((res: any) => {
    if (res.success) {
      pdtFee.value = 0
      adtFee.value = 0
      tableData.value = res.data.platformOrders
      isChoice.value = res.data.platformOrders[0]?.tags.includes(4)
      tableData.value.forEach((item: any) => {
        pdtFee.value += item.productPaymentFreezeAmount
        adtFee.value += item.productAdditionFreezeAmount
      })
      setTimeout(() => {
        table.value?.expandAllChange()
      }, 100)
    }
  })
}
getDetail()
const unit = computed(() => {
  if (tableData.value.length === 0) return ''
  return showCurrentUnit(tableData.value[0]?.goodsCountry === COUNTRY.KR)
})
const orderItem: any = ref({})
const goodsRowItem: any = ref({})
const goodsAdditionList: any = ref(null)
const additionCountryCode: any = ref({})
const additionVisible: any = ref(false)
const openAddition = (row: any, order: any) => {
  goodsRowItem.value = {
    ...row,
    platformOrderItemAdditionDTOList: (row.platformOrderItemAdditionList === '-' ? [] : row.platformOrderItemAdditionList ?? [])?.map((item: any) => {
      return {
        ...item,
        washedlabelSpecification:
          item.washedlabelSpecification === '-'
            ? ''
            : item.washedlabelSpecification,
        spotCheckRatio: item.spotCheckRatio && item.spotCheckRatio !== '-' ? item.spotCheckRatio : ''
      }
    })
  }
  orderItem.value = order
  goodsAdditionList.value = row.platformOrderItemAdditionList?.map((item: any) => {
    return {
      ...item,
      washedlabelSpecification: item.washedlabelSpecification === '-' ? '' : item.washedlabelSpecification
    }
  }) ?? []
  additionCountryCode.value = order.goodsCountry
  additionVisible.value = true
}
const handleAdt = (adt: any) => {
  editOrderGoodsAdditionApi({
    platformOrderId: orderItem.value?.platformOrderId,
    platformOrderItemIdList: [goodsRowItem.value.platformOrderItemId],
    cartAdditionList:
      adt === 1
        ? []
        : adt.map((i: any) => {
          return {
            shopProductSku: goodsRowItem.value.shopProductSku,
            additionConfigId: i.additionConfigId,
            additionId: i.additionId,
            ingredientsSku: i.ingredientsSku === '-' ? '' : i.ingredientsSku,
            additionExtraName: i.additionExtraName,
            washedlabelAdditionId:
              i.washedlabelAdditionId === '-' ? '' : i.washedlabelAdditionId,
            washedlabelSpecification:
              i.washedlabelSpecification === '-'
                ? ''
                : i.washedlabelSpecification,
            spotCheckRatio: i.spotCheckRatio && i.spotCheckRatio !== '-' ? i.spotCheckRatio : '',
            spotCheckFlag: i.spotCheckFlag
          }
        }),
    noAdditionalFlag: adt === 1 ? 1 : 0
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('修改成功'))
      // getDetail()
      confirmOrderDetailApi({
        platformOrderIds: route.query.id?.toString().split(',') || []
      }).then((res: any) => {
        if (res.success) {
          const data = res.data.platformOrders
          const resultOrderIndex = data.findIndex(v => v.platformOrderNo === orderItem.value.platformOrderNo)
          const tableOrderIndex = tableData.value.findIndex(v => v.platformOrderNo === orderItem.value.platformOrderNo)
          tableData.value[tableOrderIndex] = data[resultOrderIndex]
          pdtFee.value = 0
          adtFee.value = 0
          tableData.value.forEach((item: any) => {
            pdtFee.value += item.productPaymentFreezeAmount
            adtFee.value += item.productAdditionFreezeAmount
          })
        }
      })
    }
  })
}
const noAdd = (row: any, order: any) => {
  orderItem.value = order
  goodsRowItem.value = row
  handleAdt(1)
}
const changeTransportType = (row: any, type: number) => {
  editTransportTypeApi({
    platformOrderId: row.platformOrderId,
    transportType: type
  }).then(({ success }: any) => {
    if (success) {
      getDetail()
    }
  })
}
const shopWallet = ref(0)
const getBalance = async () => {
  const wallet = await getWallet({
    customerShopId: store.getters.curShop,
    currencyCode: 'CNY'
  }).then((res) => res.data.availableAmount)
  shopWallet.value = wallet
  return wallet
}
getBalance()
const paySuccess = async () => {
  await getBalance()
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["usercenter-order-confirm-order", { 'bg-restock': isRestockOrder.value }])
  }, [
    (!isRestockOrder.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('确认订单信息')), 1),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(STable, {
              tableData: tableData.value,
              columns: isChoice.value ? _unref(choiceColumns) : _unref(columns),
              tableConfig: tableConfig,
              showPagination: false,
              ref: (_value, _refs) => {
                _refs['table'] = _value
                table.value = _value
              }
            }, {
              expand: _withCtx(({ scope }) => [
                _createVNode(STable, {
                  tableData: scope.row.platformOrderItems,
                  columns: isChoice.value ? _unref(choiceChildColumns) : _unref(childColumns),
                  showPagination: false
                }, {
                  productSkuImg: _withCtx(({ row }) => [
                    _createElementVNode("img", {
                      src: row.productSkuImg,
                      alt: "",
                      style: {"width":"60px"}
                    }, null, 8, _hoisted_3)
                  ]),
                  frezeeQuantity: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.freezeQuantity) + "/" + _toDisplayString(row.sellQuantity), 1)
                  ]),
                  platformOrderItemAdditionList: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_unref(montageAddition)(row.platformOrderItemAdditionList)) + " ", 1),
                    (row.productType === 1 && scope.row.orderSource === 10)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _withDirectives(_createVNode(_component_el_radio, {
                            "model-value": row.noAdditionalFlag === 1,
                            size: "small",
                            label: true,
                            style: {"margin-right":"0"},
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"])),
                            onChange: ($event: any) => (noAdd(row, scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
                            ]),
                            _: 2
                          }, 1032, ["model-value", "onChange"]), [
                            [_vShow, (!row.platformOrderItemAdditionList?.length || row.platformOrderItemAdditionList === '-')]
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("a", {
                              onClick: _withModifiers(($event: any) => (openAddition(row, scope.row)), ["stop"])
                            }, _toDisplayString(_unref(t)('编辑')), 9, _hoisted_5)
                          ]),
                          _withDirectives(_createElementVNode("div", { class: "add-valid-text" }, _toDisplayString(_unref(t)('附加项验证')), 513), [
                            [_vShow, (!row.platformOrderItemAdditionList && row.noAdditionalFlag !== 1)]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  actualPrice: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(row.actualPrice) + " " + _toDisplayString(_unref(unit)), 1)
                  ]),
                  productAdditionFreezeAmount: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(row.productAdditionFreezeAmount) + " " + _toDisplayString(_unref(unit)), 1)
                  ]),
                  allIncludeProductPrice: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(row.allIncludePriceResultDetail?.allIncludeProductPriceExchange) + "円（" + _toDisplayString(row.allIncludePriceResultDetail?.allIncludeProductPrice) + "元） ", 1),
                    (row.allIncludePriceResultDetail)
                      ? (_openBlock(), _createBlock(AllPriceDetail, {
                          key: 0,
                          detail: row.allIncludePriceResultDetail,
                          season: row.season,
                          transportType: scope.row.transportType
                        }, null, 8, ["detail", "season", "transportType"]))
                      : _createCommentVNode("", true)
                  ]),
                  totalFreezeAmount: _withCtx(({ row }) => [
                    (!isChoice.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(row.totalFreezeAmount) + " " + _toDisplayString(_unref(unit)), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(row.allIncludePriceResultDetail?.allIncludeProductTotalPriceExchange) + "円（" + _toDisplayString(row.allIncludePriceResultDetail?.allIncludeProductTotalPrice) + "元） ", 1))
                  ]),
                  _: 2
                }, 1032, ["tableData", "columns"])
              ]),
              productPaymentFreezeAmount: _withCtx(({ row }) => [
                _createElementVNode("div", null, _toDisplayString(row.productPaymentFreezeAmount) + " " + _toDisplayString(_unref(unit)), 1)
              ]),
              productAdditionFreezeAmount: _withCtx(({ row }) => [
                _createElementVNode("div", null, _toDisplayString(row.productAdditionFreezeAmount) + " " + _toDisplayString(_unref(unit)), 1)
              ]),
              totalFreezeAmount: _withCtx(({ row }) => [
                (!isChoice.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(row.totalFreezeAmount) + " " + _toDisplayString(_unref(unit)), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(row.platformOrderItems?.reduce((acc, v) => acc +
                v.allIncludePriceResultDetail?.allIncludeProductTotalPriceExchange, 0)?.toFixed(0)) + "円（" + _toDisplayString(row.platformOrderItems?.reduce((acc, v) => acc +
                  v.allIncludePriceResultDetail?.allIncludeProductTotalPrice,
                  0)?.toFixed(2)) + "元） ", 1))
              ]),
              transportType: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(row.transportType === 1 ? _unref(t)('海运') : _unref(t)('空运')) + " ", 1),
                  (row?.totalFreezeAmount * row.exchangeRate >= 150000)
                    ? (_openBlock(), _createBlock(_component_el_dropdown, {
                        key: 0,
                        trigger: "click",
                        "popper-class": "choice-shop-pop"
                      }, {
                        dropdown: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["dropdown-item flex-ter", { active: row.transportType === 1 }]),
                              onClick: ($event: any) => (changeTransportType(row, 1))
                            }, [
                              _createElementVNode("div", _hoisted_14, [
                                (row.transportType === 1)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                                  : _createCommentVNode("", true)
                              ]),
                              _hoisted_16,
                              _createElementVNode("span", null, _toDisplayString(_unref(t)('海运')), 1)
                            ], 10, _hoisted_13),
                            _createElementVNode("div", {
                              class: _normalizeClass(["dropdown-item flex-ter", { active: row.transportType === 2 }]),
                              onClick: ($event: any) => (changeTransportType(row, 2))
                            }, [
                              _createElementVNode("div", _hoisted_18, [
                                (row.transportType === 2)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                                  : _createCommentVNode("", true)
                              ]),
                              _hoisted_20,
                              _createElementVNode("span", null, _toDisplayString(_unref(t)('空运')), 1)
                            ], 10, _hoisted_17)
                          ])
                        ]),
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["tableData", "columns"])
          ])
        ], 64))
      : (_openBlock(), _createBlock(RestockTable, {
          key: 1,
          onRefreshData: getDetail,
          loading: false,
          order: tableData.value?.[0] ?? {}
        }, null, 8, ["order"])),
    _createVNode(FigurePay, {
      hiddenGroupBtn: true,
      onSubmit: submit,
      pdtFee: pdtFee.value,
      adtFee: adtFee.value,
      ref: (_value, _refs) => {
        _refs['figurePayRef'] = _value
        figurePayRef.value = _value
      },
      emitSubmit: true,
      "is-choice": isChoice.value,
      choiceTotalAmount: _unref(choiceTotalAmount)
    }, null, 8, ["pdtFee", "adtFee", "is-choice", "choiceTotalAmount"]),
    _createVNode(NoStockModal, {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      goods: goods.value,
      blackGoods: blackGoods.value
    }, null, 8, ["visible", "goods", "blackGoods"]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (goodsAdditionList.value)
          ? (_openBlock(), _createBlock(AdditionDrawer, {
              key: 0,
              list: goodsAdditionList.value,
              "onUpdate:list": _cache[2] || (_cache[2] = ($event: any) => ((goodsAdditionList).value = $event)),
              onCommit: handleAdt,
              type: "AdtOrder",
              proxy: goodsRowItem.value,
              countryCode: additionCountryCode.value,
              noSpot: goodsRowItem.value.orderQuantity === 1
            }, null, 8, ["list", "proxy", "countryCode", "noSpot"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })),
    _createVNode(Recharge, {
      ref: (_value, _refs) => {
        _refs['rechargeRef'] = _value
        rechargeRef.value = _value
      },
      choiceTotalAmount: _unref(choiceTotalAmount),
      shopWallet: shopWallet.value,
      onSuccess: paySuccess
    }, null, 8, ["choiceTotalAmount", "shopWallet"]),
    _createVNode(CreateOrderSuccess, {
      ref: (_value, _refs) => {
        _refs['createOrderSuccessRef'] = _value
      }
    }, null, 512),
    _createVNode(UnRechargeModal, {
      ref: (_value, _refs) => {
        _refs['unRechargeModalRef'] = _value
      }
    }, null, 512),
    _createVNode(UnBalanceConfirm, {
      ref: (_value, _refs) => {
        _refs['unBalanceConfirmRef'] = _value
        unBalanceConfirmRef.value = _value
      }
    }, null, 512)
  ], 2))
}
}

})